import React, { PropTypes } from 'react';
import { Link } from 'react-router';

import { title as listTitle, list } from './styles.module.css';

/**
 * Footer nav presentational component.
 */
const FooterNav = ({ children, className, title, to }) => (
  <nav>
    <h4 className={listTitle}>
      {to ? <Link to={to}>{title}</Link> : title}
    </h4>
    <ul className={[list, className].join(' ')}>
      {[].concat(children).map(link => <li key={link.props.href || link.props.to}>{link}</li>)}
    </ul>
  </nav>
);

FooterNav.propTypes = {
  /**
   * Children (Link components) to append to list.
   */
  children: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.node), PropTypes.node]).isRequired,
  /**
   * String class names to append to component styles.
   */
  className: PropTypes.string,
  /**
   * String displayed at the top of the link list.
   */
  title: PropTypes.string.isRequired,
  /**
   * Optional link for the nav title.
   */
  to: PropTypes.string,
};

FooterNav.defaultProps = {
  className: '',
  to: undefined,
};

export default FooterNav;



// WEBPACK FOOTER //
// ./app/src/components/Footer/components/FooterNav/index.jsx